module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "15",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Futura_Std_Medium_Condensed_11"
  }, [_vm._v("NOW")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Subtitle--cst-",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_c('span', {
    staticClass: "Futura_Std_Light_Condensed_11"
  }, [_vm._v("Tuesday")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "Head---Level-1--h1--first"
  }, [_c('span', {
    staticClass: "Futura_Std_Bold_Condensed_11"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline---Chapter--dl-"
  }, [_c('span', {
    staticClass: "Futura_Std_Light_Condensed_11"
  }, [_vm._v("BROOKLYN, NEW YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Std-No-Indent--tx1-"
  }, [_vm._v("Rick Hayden clung to an overhead grab handle as the Volvo sedan raced along Eastern Parkway.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Can you elaborate on what we’re up to?” he said. “Just a little, okay? Like where we’re headed, for starters? And are we going to arrive alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Luis Montero had the wheel. A full-blooded Cuban, light brown skin, stocky build, dark eyes, black hair gelled into some weird and glossy configuration. Rick knew all about him. He’d backgrounded the guy before Stahlman hired him. Age thirty-two, the son of Castro refugees, Ph.D. in neurobiology, supposedly brilliant. His r"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("é")]), _vm._v("sum"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("é")]), _vm._v(" claimed he’d published a bunch of papers. Rick couldn’t understand their titles, let alone what they were about, but he’d checked the journals to make sure the articles had appeared. They had. Montero could have nabbed just about any academic position he wanted, yet he was working for Clayton Stahlman. Rick didn’t have to ask why. He’d seen all the zeros on the deal memo.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Didn’t Stahlman tell you?” Montero said, looking at Rick.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He was one of those guys who had to look at you when he spoke to you, even when he was driving.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Told me you were picking up a specimen in Brooklyn and might need a little help.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero laughed. “ ‘Specimen’? He really said that?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Could you watch the road, please? Yeah. ‘Specimen.’ ” Typical Stahlman, he’d hung up before Rick could extract any details. “Which is about as specific as ‘Brooklyn.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "16",
      "id": "pg_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Okay. The specimen is a human being named Ellis Reise who’s in trouble with one of the local families over gambling debts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“ ‘Families’ as in folks with vowels on the end of their names?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Right. Some Gambino-Mangano offshoot—I didn’t bother unraveling the relationships. All I know is it’s run by a guy named Vincent Donato.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick grunted. “Vinny Donuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You’ve heard of him then?” Looking at him again. “Not many civilians have. He keeps a low profile.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’m not your average civilian.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick’s security work for Stahlman’s varied projects and operations involved backgrounding everyone he hired. Ties to organized crime were a major no-no. Vincent “the Donut” Donato, aka Vinny Donuts, had his pudgy fingers deep into gaming, ponies, numbers, and loan sharking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You—” he began as Montero made a screeching Ralph onto Utica Avenue, swerving across the lane into oncoming traffic. “Jesus! What the hell?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Sorry,” he said as he pulled back into his lane and headed south. “The turn snuck up on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yeah, ’cause you’re looking at me instead of the road. Talk to the windshield. I have good ears. I’ll still hear you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yeah. Sure. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Where’s the next turn?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Remsen. Still a ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You keep your eyes straight, I’ll keep mine peeled. Anyway, as I was about to say before you almost killed us: You qualify as an average civilian. How come you know about Donato?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Only through researching Ellis and his gambling.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Strange way for a neurobiologist to occupy his time.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So how much is this Ellis in to Vinny Donuts?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, that’s where it gets tricky. Donato’s operation owes Ellis over four hundred grand.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What? How’d "), _c('i', [_vm._v("that")]), _vm._v(" happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Totally killed them in roulette—and they don’t want to pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Can’t blame them, but welching’s bad for business.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Mob-run games would fleece a tourist up the wazoo, but tended to play it straight with their regulars, paying out whatever the winnings. Otherwise high rollers would stay away.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "17",
      "id": "pg_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“They say he cheats. They’re going to make an example of him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Why is this our business?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Because Ellis is a valuable, um, specimen.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Just what does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero glanced at him. “If Stahlman hasn’t told you, I probably should wait until he does.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick felt a little miffed at that. He knew pretty much everything about Stahlman’s operations except …")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“This have anything to do with the Long Island City warehouse?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero nodded. “You’ve been there?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Back in the spring.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“He was just setting it up then.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yeah, well, I was talking to Stahlman when I saw something through one of the doors … or thought I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero was smiling. “Oh, like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Like a guy floating above the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero laughed. “Leo! Always showing off!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You mean he really was—?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’ll defer to the boss on that, if you don’t mind.” He leaned forward, squinting through the windshield. “Is that Remsen ahead?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yep. I was just about to—” The light went amber but Montero didn’t slow. “Aw, you’re not gonna—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Yep. It turned red and he kept going, skidding into the turn as he ran through it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We in a hurry?” Rick said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Kinda. I’d like to get to Ellis while he’s still alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Stahlman sends a Ph.D. to deal with the mob?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I sort of have to go because I’m the only one who knows about Ellis. He sent you along to do the dealing. That is, should any dealing be needed.” He glanced at Rick. “And I can see why.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I mean, look at you. If I saw you coming I’d get out of the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hey, I know I’m not a small guy, but I’m not "), _c('i', [_vm._v("that")]), _vm._v(" big.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s not size, it’s—I don’t know. You’re like a coiled spring. You look like you could be a nice guy or very dangerous—either way, depending on the situation.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "18",
      "id": "pg_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Not the first time Rick had heard that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Whatever. So anyway, Donato’s people are right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“About Ellis cheating?” Montero paused, looking like he had to think about that. “Yes and no.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Gotta be one or the other. Either he’s cheating or he isn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Oh, he’s definitely cheating, but he doesn’t know it. He just thinks he’s lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Winning over four hundred K in roulette? That’s "), _c('i', [_vm._v("very")]), _vm._v(" lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Especially when you consider he started with a ten-dollar chip and only played three spins.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick tried to do the math. “Had to be letting it ride each time.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Exactly. He won on his first number which, at thirty-five to one, netted him three-fifty for his ten bucks. They allowed him to let his winnings ride on another number, which he also won. At another thirty-five to one, the house now owed him over twelve grand.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“And they let him ride again? No table limits?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’m sure somebody’s in big trouble for suspending the limit, but you can see why they’d take the risk to get back their twelve grand. I mean, the chance of hitting a number on the nose is about two-point-five percent. The chance of hitting your number three times in a row is still two-point-five percent, but the house figured no way that could happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero managed to take the right fork off Remsen onto Ralph without incident or drama.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Obviously it did. So how do they plan to make an example of him?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Disappear him. Crush him inside one of Vinny’s scrap cars and dump him in the Atlantic along with—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Truck-truck-truck!” Rick shouted, pointing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero had been looking at him and didn’t see the big box truck backing out of a driveway. He slammed on the brakes and the Volvo screeched and fishtailed to a stop. The driver looked at them with a WDF look, as in "), _c('i', [_vm._v("what da fuck?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Get out!” Rick said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Get out. I’m gonna drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“No-no-no. It’s okay. I promise. Not far now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick paused, then relented. He pointed at the receding truck. “Stay behind "), _c('span', {
    attrs: {
      "aria-label": "19",
      "id": "pg_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("him.” After a few hundred yards, he said, “What did you say about dumping him in the Atlantic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Vinny owns a scrap yard and a trawler, in case you didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Didn’t. And you know about this how?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We’ve had Ellis’s phone hacked for a while, and added Vinny’s capo’s just recently.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“How’d you manage that? Oh, Kevin Hudson, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman liked to hire ex-hackers for his IT matters. He’d had a fellow named Russ Tuit for a while, but he’d left to work for the NRO, of all places. Before leaving he’d recommended Kevin. Rick had checked him out and he passed muster, so now he was Stahlman’s go-to guy for IT.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Right. Kevin’s amazing. Anyway, Donato and his crew are talking about having the croupier and the guy who suspended the table limit keep Ellis company so he doesn’t get lonely while he sleeps with the fishes. Ellis thinks he’s meeting them at the scrap yard for his payout.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“He as dumb as he sounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero smiled. “Don’t be too hard on him. He’s an astounding pool player but has a weakness for cards. He’s played Donato’s games before—poker and blackjack usually—and he’s won and lost with never a problem collecting when he won. Last night was the first time he’d ever tried roulette and he thinks he was astoundingly lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“But you say he cheated. How?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero chewed his lip. “I guess I can tell you what we "), _c('i', [_vm._v("think")]), _vm._v(". We still need to prove it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("All this beating around the bush.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“For Chrissake, spill, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“All right, all right. We think he’s telekinetic.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("That took a bit of digesting. “You mean he moves things with his mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Or brain.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Same difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Not even close. But yes, he can move things without touching them. That’s how he can run a pool table every time he picks up a cue.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“And can hit a roulette number three times in a row.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Exactly. I’m thinking he visualizes a pool ball dropping into a certain pocket or a roulette ball dropping into a certain slot, and it just … does.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "20",
      "id": "pg_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“And now he’s visualizing this middle-level mob boss just handing over four hundred K?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yeah. I was hoping we could head him off at the pass but he got a head start.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The neighborhood around Ralph Avenue had deteriorated from redbrick residential to car-parts-and-repairs commercial.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What’s he driving?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A red Kia Forte.” He pointed to a train trestle over the road. “Okay, once we pass that we’re officially in Canarsie. Look for Preston Court.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick spotted it two blocks in. Montero hung a right onto an even crummier street with rusting warehouses, scrap yards, and bumpy, crumbling pavement that showed more dirt than asphalt. He pointed to a scrap yard on the left as they passed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“That’s Donato’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick saw "), _c('i', [_vm._v("Preston Salvage")]), _vm._v(" on a canted sign slung over a gap in the corrugated steel wall that served as an entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Not ‘Vinnie’s Vehicles’ or ‘Donato’s Discards’?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Told you: He’s low profile. Doesn’t want his name out there. He came up during the days of the Dapper Don; he saw how Gotti became a lightning rod for the feds.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Think he’s there now?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Doubt it. If his guys are going to disappear Ellis, he’ll want to be visible elsewhere—like having dinner at Peter Luger or the like.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“All right. Turn around. I’ll go in and see what’s happening.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Park across the entrance so nobody gets in or out, and be ready to drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What are you planning?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick had no idea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Gotta play it by ear. What’s this Ellis look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A weasel. Sort of Anthony Weinerish.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero stopped the car.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You carrying?” he said as Rick got out.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick grinned. “You just said ‘carrying.’ Don’t say ‘carrying.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Just don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "21",
      "id": "pg_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Okay, are you armed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“With what?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Guns, knives, bludgeons, chainsaws. The usual. Why’re you asking?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I just don’t want to have to call 911 for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I appreciate the thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick stepped over the chain strung low across the entrance. Straight ahead sat a two-story clapboard structure—looked like a garage on the ground floor with outside stairs leading up to an office on the second level. Two cars parked in front, neither a red Kia. Maybe in back …")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He walked around to the left and saw piles of flattened junkers clustered around a crusher behind the building. In front of the crusher a guy was siphoning gas from the tank of a red Kia into an even redder gas can. That gave Rick a second’s pause; then he realized if they were planning to crush Ellis in his Kia, a full gas tank could be dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The garage had double overhead doors, one of which was up. A quick glance revealed three men of various sizes, all duct-taped, hand, foot, and mouth. One of them, a guy with hair so gelled it probably reflected X-rays, had a definite Weineroid look.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Let me guess: Ellis Reise plus the croupier and the reckless pit boss.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick pulled a knife from his front pocket but kept it hidden in his fist with the four-inch blade folded. All it would take to free it was a flick of his thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He poked his head inside for a quick look around. No one else besides the three bound men.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Nice. Maybe this would work out with no hassles. Spirit Reise away with no one the wiser until later.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Who the fuck are you?” said a voice behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Shit.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick turned to see the guy from outside, standing there with a plastic gas can in each hand.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hey, I just stopped by to see about getting a little cash for my old junker but I see you’re in the middle of something so I’ll just—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You’ll just nothin’, asshole.” He dropped the cans and grabbed a tire iron. “Sit down over there with the others.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Now wait a minute,” Rick said, slipping the knife into a back pocket. "), _c('span', {
    attrs: {
      "aria-label": "22",
      "id": "pg_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("He was going to need both hands. “I didn’t see nothin’ so I’m just gonna ease on down the road and—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He’d started moving toward the door as he spoke, but the gas guy had a different idea. He swung the tire iron at Rick’s head. Rick ducked, came up as it whistled by above him, grabbed the arm with the iron and yanked it down while bringing up his knee. Arm and knee connected at the elbow, which bent backward, a direction not allowed in its design, and broke with a grisly snap.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The gas man turned dead white, his tire iron hit the floor, followed immediately by his knees. Clutching his elbow he bent over as if praying toward Mecca and blew dinner chunks all over the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Yeah, that had to hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick flipped open his knife and cut the duct tape on Ellis Reise’s wrists and ankles.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise ripped the tape off his mouth. “I don’t know who you are,” he said in a voice that could have passed for Joe Pesci’s, “but am I glad you came along. Just watch out for Joey.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Joey?” Rick looked around. He’d expected at least two, considering the two cars out front. “Where would he be?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“He went upstairs to the office.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Sure enough, footsteps started pounding down the outside stairway. Rick motioned for Reise to be quiet, then picked up the tire iron and stood by the doorway. Now, if Joey could just pass the windows on the side of the garage without looking in …")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Tone?” The cry was tinged with alarm. “Tony!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Joey had looked, damn him. Rick bent into a crouch and readied the tire iron in a two-handed grip.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("When Joey entered, pistol in hand, Rick swung for the fences, catching a knee in mid-stride. As Joey’s eyes bulged with pain, Rick struck again, this time at the gun arm. The radius gave off a loud "), _c('i', [_vm._v("crack")]), _vm._v(". Joey and his semi-auto clattered to the floor. Rick booted the pistol out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise’s eyes were bulging almost as much as Joey’s. “Who "), _c('i', [_vm._v("are")]), _vm._v(" you, man?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick didn’t know how to answer that so he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise continued to stare. “You are fucking scary, you know that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick shrugged. Probably seemed that way as far as the average person "), _c('span', {
    attrs: {
      "aria-label": "23",
      "id": "pg_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("was concerned. He’d been trained to put the hurt on without hesitation when necessary, and not to apply more than necessary. Even though people didn’t consciously perceive the lack of hesitation, they sensed it, and that was what scared them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Get their phones,” he told Reise. “And if Tony there has a gun, get that too.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Tony had a revolver and an iPhone, but was still in too much agony to offer resistance or even speak.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Not so Joey. As he was relieved of his phone, he managed, “You’re a dead man, Reise. Dead man walking.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Not so tough now, are you?” Reise said, standing over him. “ ‘Reise’s pieces’? ‘Reise is gonna be in pieces’? Where are the wisecracks now, asshole?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He kicked Joey in the ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("None too gently, Rick grabbed Ellis’s arm and yanked him away. “Don’t do that. Don’t ever do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Beat on a guy who’s out of the fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“He was mouthing off.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Do "), _c('i', [_vm._v("not")]), _vm._v(" do that. It’s low rent.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He spotted Joey giving him a strange look.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise turned back to the mobsters and yelled, “Where’s my money? You owe me 428,750 dollars and I want every fucking penny!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("That did it. Wishing he’d left the tape over Reise’s mouth, Rick threw the phones and revolver out the door. How stupid was this guy?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You kidding me?” he said, this time grabbing Reise by his scrawny neck and propelling him out into the night. “Forget about your money. You won’t be seeing a penny of it. You’re lucky you’re alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hey! Where we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He steered him toward the entrance where Montero’s Volvo idled. “Somebody wants to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A guy who knows more about you than you know about yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What?” He started struggling. “I ain’t getting in no car with somebody I don’t know!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick towered over Reise who weighed next to nothing. Tightening his "), _c('span', {
    attrs: {
      "aria-label": "24",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("grip on his neck, he lifted the scrawny man off his feet and carried him kicking and twisting to the Volvo where he threw him into the front seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“This man is going to drive you someplace safe and you’ll listen to what he has to say along the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“No fucking way!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“There’s still a whole roll of duct tape back there,” Rick said. “Only take me a few seconds to go get it. Your choice. Because one way or another you’re going with him. We clear?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("That took some of the starch out of Reise. “My car,” he whined.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Damn.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’ll bring it. You sit and listen.” Rick leaned over and looked at Montero. “The warehouse?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero nodded. “Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Meet you there.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He watched the Volvo zoom off, wondering if Ellis would survive the drive to Long Island City, then headed back to refill the Kia’s tank. As he retrieved the gas cans, he found the garage pretty much as he’d left it. Tony was now lying on his side next to his vomit, still clutching his elbow. Joey had risen to a sitting position and, with his good arm, was half crawling toward his gun and phone outside.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Ignoring Joey’s howls of pain, Rick dragged him back to Tony and zip-tied their good arms together.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You seem like a stand-up guy,” Joey said. “How come you’re involved with that little shit?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’m not. Guy I work for is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We’re gonna have to come after you, y’know.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Not necessarily. Tell Mister Donato that Reise’s debt is settled. He doesn’t owe him anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“But me and Tony owe you,” Joey said. “Look at his elbow. And you broke my arm. We owe you big time.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I didn’t come here for a fight,” Rick said. “If your pal hadn’t started swinging a tire iron and you hadn’t been pointing a gun, things’d be different right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Still …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick moved closer and stood over him, giving him a hard look. “Hey, you’re not going to become a problem now, are you? I’ve learned the hard "), _c('span', {
    attrs: {
      "aria-label": "25",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("way that unsolved problems have a habit of biting you in the ass when you least expect it, so I don’t like to leave them lying around. Get what I’m saying? Now, are you going to be a problem?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Joey looked away. “Guess not.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick took a quick look around. The two other guys were still bound and gagged. He considered cutting them free, then decided against it. They might try to take him down to get back in good with their boss.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("What we have here, he thought, is what you might call a family matter. Best not to interfere.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He shook his head. The things Stahlman asked him to do at times …")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Good thing he paid well.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("As he replaced the Kia’s gas, he thought about Ellis Reise and his supposed ability to move things with his mind. He’d leave it a "), _c('i', [_vm._v("supposed")]), _vm._v(" ability until he’d seen it up close and personal. If true, it would give him a great excuse to call Laura and get her involved.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Not so long ago he’d figured he wouldn’t ever again need an excuse to call her, but things between them hadn’t gone the way he’d hoped. Not even close.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "Head---Level-1--h1-"
  }, [_c('span', {
    staticClass: "Futura_Std_Bold_Condensed_11"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline---Chapter--dl-"
  }, [_c('span', {
    staticClass: "Futura_Std_Light_Condensed_11"
  }, [_vm._v("QUEENS, NEW YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Std-No-Indent--tx1-"
  }, [_vm._v("Rick remembered the address of Stahlman’s warehouse—a quarter mil square feet spread over two floors in one of the older buildings squatting in the industrial zone between Queens Boulevard and the LIE. Traffic was light and he made good time. Some guy on the radio was talking about how we’d just passed the autumnal equinox, that day every September when the nights started running longer than the days. It meant summer was over and fall was taking charge.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He parked the Kia at the end of the block and walked to a steel door under a heavy-duty roll-up security shutter that served as the entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He liked how the ground-floor windows were set high, a good ten feet off the pavement. Made it easier to keep out the rats—human and otherwise. "), _c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("He knocked, waved at the security camera, and was buzzed in. Ad"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ã")]), _vm._v("o Guerra loomed behind a desk that looked too small for him. Rick had backgrounded him for a security position earlier in the year.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hey, Mister Hayden,” he said, extending his hand. “The doc said you’d be coming soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“The boss here?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Guerra nodded and pointed. “With the doc and the new guy right through there.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Another buzz and the door to Rick’s right unlatched, allowing him into a huge rectangular space running four hundred feet on its long side, with fifteen-foot ceilings. The floor had been divided into curtained areas of varying sizes. Dead ahead, Stahlman, Montero, and Reise stood staring at a flat-screen TV mounted on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You mean you’ve been "), _c('i', [_vm._v("spying")]), _vm._v(" on me?” Reise was saying as Rick approached.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Clayton Stahlman spotted him and motioned him aside.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Mister Hayden,” he said, offering his hand. “I hardly see you anymore. I miss our talks.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Always "), _c('i', [_vm._v("Mister Hayden")]), _vm._v(", never "), _c('i', [_vm._v("Rick")]), _vm._v(". And because they’d had little face-to-face contact since Stahlman’s cure, Rick still experienced a pop of surprise at his healthy appearance. The man who’d hired him years ago had been a frail, feeble, moon-faced ghost, sucking oxygen twenty-four/seven as he dwindled away in his wheelchair. Although his barrel chest remained as a reminder of the pulmonary fibrosis that had almost laid him low, he now looked younger than his late sixties, a picture of senior citizen health.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So do I,” Rick lied. He liked Stahlman, but wasn’t looking to be buddies. He gestured toward Reise. “This on the up-and-up?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“His telekinesis? I believe so. Come over here and listen in on Doctor Montero explaining it to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“… and I’m betting you could run any table any time you want,” Montero was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise gave a self-satisfied shrug. “Yeah, I suppose.” He spotted Rick. “You!” He jabbed an index finger toward Montero. “You put me in a car with a fucking maniac!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I almost got killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Better than definitely killed if you’d stayed at the scrap yard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise didn’t seem to have a response to that.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Let’s stay on topic, shall we?” Montero said. “You could run a pool table every time, but you don’t. Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise gave him a "), _c('i', [_vm._v("dumb question")]), _vm._v(" look. “I’d never get anyone to bet against me if I didn’t miss once in a while!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman leaned close to Rick and spoke in a low voice. “We were tipped to Ellis, so—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Tipped how?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s complicated. You’ll meet her soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Everything was complicated. And who was “her”?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Anyway,” Stahlman went on, “over the summer we set up a camera above his favorite pool table, supposedly as a promotion for the camera-and-playback system. At the end of a game, players could replay their best shots on the connected TV. The owner was cool with the free installation and the players loved the overhead shots. They felt like they were in a televised match.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero said to Reise, “But your pool hustles were just to finance your poker, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A smile. “Cards are where it’s at.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“But while you were hustling your fellow players and having fun taking their money,” Montero said, “we had a computer analyzing all the shots on the table, and that’s how we found you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The smile faded. “What’s that mean? ‘Found’ me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Very simple,” Montero said. “Your strokes tend to break the laws of physics.” He worked the remote in his hand. “Easier if I show you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("An overhead shot of a pool table filled the TV screen on the wall. A stick struck the white cue ball, which then struck the red three ball, sending it flying toward a corner pocket. The screen froze after the red had traveled two feet. A dotted line appeared, connecting the ball to the cushion just to the left of a corner pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Here’s a stroke by one of your opponents,” Montero said. “Computer analysis of the speed, direction, and rotation of the ball predicts that this shot will miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The screen came to life again and, sure enough, the ball bounced off the cushion exactly where predicted.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Another stick appeared, struck the cue ball, which in turn struck the "), _c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("striped twelve ball. Again action was stopped and another dotted line appeared, showing this shot would miss too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“This is your shot, Ellis. The computer says you’re going to narrowly miss too, but watch what happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The ball began rolling again, following the projected path for another foot or so, and then deviating just enough to land in the pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Proves nothing,” Reise said. “Except maybe your software needs fixing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Montero sighed. “I understand how you’re in denial. But I can stand here all night and show you example after example of how your opponents’ shots follow the predicted path to the millimeter and yours do not. You’re unconsciously influencing the path of the balls, Ellis.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Come on,” he said with a tremulous attempt at a smile. “That’s Harry Potter stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“How are you at cards, Ellis?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A shrug. “Pretty good. Better than average.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“How come you’ve never played roulette before?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s a sucker’s game.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“And yet you won four hundred grand your first try.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Four hundred twenty-eight-plus.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So, you’re unbeatable in pool and you broke the bank your first time out in roulette. What do those two games have in common?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise averted his gaze. “Balls.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick was convinced, and he could see Reise’s resistance crumbling.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Right. Moving objects that can be influenced by someone with telekinesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Reise shook his head, his voice barely a whisper. “Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman slapped Rick’s shoulder. “Let’s repair to my office, shall we?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The office turned out to be a windowless box with bare walls, a scarred desk, and two chairs. Rick didn’t know Clayton Stahlman’s exact net worth, but if it didn’t sport nine zeroes, it didn’t miss by much. At the end of the nineties he’d cashed out of the dot-com revolution before it imploded and invested elsewhere. He’d told Rick once that, no matter how he tried, he couldn’t spend even the interest on his holdings, let alone dent the principal, and so his net worth kept growing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("What Rick liked was how unimpressed Stahlman was with his wealth. This office was a perfect example. Function took precedence over form. No "), _c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("bells and whistles, just a private place to set his ass down and open his laptop and make calls on his cell.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Was I right sending you along with the doc?” he said, indicating the office’s second chair. “Did you need to intervene?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A little. Nothing that won’t heal.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Good.” He pulled a bottle of booze and a couple of glasses from one of his desk drawers. “That calls for a celebration.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What are we celebrating?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman poured two fingers of amber fluid into each glass. “Locating another nadan"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ý")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Reise?” Rick said, accepting the glass. “I’d say he’s more of a ninny. What’s a nadan"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ý")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A Slovak word I picked up from my grandmother. It means ‘gifted.’ ” He reached his glass toward Rick. “Cheers.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("They clinked, Rick sipped, and flavors exploded in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Holy crap, what is this? I mean, I know it’s Scotch, but … wow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s from the Isle of Arran, finished in a wine cask—Amarone, to be specific.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick sipped again. Man, he could get used to this stuff. He leaned back and stared at Stahlman.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So what’s the deal here? You said ‘another nadan"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ý")]), _vm._v(".’ You’ve got more people who can make pool balls roll the wrong way?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman smiled. “As a matter of fact, yes. One other telekinetic. I’ve also found a guy who can levitate, one who can make things disappear, another who can generate heat with his hands, a—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick had to laugh. “So what do we call you now? Professor X?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman’s lips gave a wry twist. “If only!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What other … gifts?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“The most impressive is a gal who can teleport.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick straightened in his chair. “Bullshit.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman raised a hand. “I swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“But that’s … that’s amazing.” He pushed his empty glass across the desktop. “So amazing I think it calls for more celebrating.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman grinned and added a generous pour to both glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’ll drink to that. But this teleporter … she hates her gift. Convincing her to use it is like pulling teeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“It’s painful?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“No. Let’s just say she’s a teenager and she has issues and leave it at that for the moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Okay, but …” Rick spread his hands. “What’s the point?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman smiled. “You mean, what’s in it for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, commercial applications are your thing. Where’s the profit?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I don’t know yet. Probably none. Be nice to learn if these gifts can be taught. Wouldn’t that be something? But in the end I expect this will turn out to be just a fascinating way to waste my excess cash.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You can always throw some my way. Less complicated.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman leaned forward. “Are you short? Just say the word and—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick waved him off. Stahlman paid him plenty. “Just kidding. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Okay. But any time …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Anyway, right now we’re at the basic research stage. I’m paying the nadan"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ý")]), _vm._v("—even housing some of them in apartments I built on the second floor. In return they allow Doctor Montero to test the limits of each gift and see if there’s some way they can enhance it. And as I said, hopefully find a way it can be learned by others.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick had known Clayton Stahlman long enough to sense something else at work here.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“There’s more, isn’t there?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman nodded. “For me, the real question isn’t the nature of their gifts, but how they obtained them. I mean, why them and not you or me? Is there a common thread that connects them?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick figured he’d like to know that too. For his own reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, if Montero comes up empty, you can always fall back on alien abductions.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman laughed. “If anyone else said that, I’d be sure he was joking. But with you …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick spread his hands. “Hey, you know I’m not into aliens. ICE, on the other hand …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Ah, yes. Your Intrusive Cosmic Entities.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yep. And they’ve earned the "), _c('i', [_vm._v("I")]), _vm._v(" in Intrusive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, I suppose bestowing these gifts on random people would certainly qualify as intrusive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Rick was still having trouble wrapping his mind around the nadan"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ý")]), _vm._v(". Really, a girl who could teleport?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So these gifts are for real?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman held up a hand, oath-taking style. “For real.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“And it involves their brains?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A nod. “Most certainly. Doctor Montero says their abilities are associated with some sort of brain-wave activity that I don’t pretend to understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You’ve got to let Laura get involved,” Rick said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Doctor Fanning? I’d love to see her again. If she’s interested, she’s welcome, of course, but …” He smiled. “These folks aren’t dead yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“She’s quitting the ME’s office and applying for a neurology residency. This would be right up her alley.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Stahlman spread his hands. “I owe her my health … my life. She can be in as deep and for as long as she wants to be. Are you seeing her tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Um, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Talking to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hadn’t planned on it, but I guess—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I thought you two had a thing going,” he said with a frown.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Was it that obvious the “thing” had died?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We’ve kind of drifted apart.” Rick didn’t want to talk about it. “But I’ll call her on this. Call her tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Just make sure she knows this whole project is sub rosa.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("But first she had to take his call. Sometimes she did, sometimes she didn’t.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "Head---Level-1--h1-"
  }, [_c('span', {
    staticClass: "Futura_Std_Bold_Condensed_11"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline---Chapter--dl-"
  }, [_c('span', {
    staticClass: "Futura_Std_Light_Condensed_11"
  }, [_vm._v("SHIRLEY, NEW YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Std-No-Indent--tx1-"
  }, [_vm._v("Laura checked the caller ID.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("Rick.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("His first call in a while. And that made sense. They’d run out of things to say. Not his fault. She’d been the one to pull back, not him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The D"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ü")]), _vm._v("sseldorf atrocity … those children. Her mind understood, "), _c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("sympathized, even agreed to some extent, but her heart, the emotional side of her, couldn’t tuck it away and keep it out of sight. It kept slithering free.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Would he ever do something like that again? She couldn’t imagine him or anyone else being faced with a choice like that twice. But just knowing what he’d been capable of in the past had tainted her feelings and their relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Oh, hell.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She hit "), _c('i', [_vm._v("TALK")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Rick?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Hey, Laura.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Hey, Rick.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“What’s up?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Awkward, awkward, awkward.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Not much. Oh, as of yesterday I’m officially in the residency matching program.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("When she’d decided to change the focus of her career from dead people to the living, this year’s residency match had been over and done. She’d have to wait for the match for next year.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("All medical school seniors—and doctors already in practice, like her—looking for post-graduate residencies in specialty training had to go through the National Resident Matching Program. She’d had to wait till now to enter her name for a neurology residency. Rick had called it the “residency Sorting Hat,” and in a way that was true. Now that she was in, she could set up interviews with the neurology departments of area medical centers like Columbia, Mount Sinai, Stony Brook, and NYU/North Shore. She needed a place within an easy commute.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Great. Still neurology?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Good. ’Cause that’s why I’m calling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“About my residency?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“No, about neurology. Stahlman’s into something very strange that might interest you. In fact I")]), _vm._v(" know "), _c('i', [_vm._v("it will interest you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Stahlman?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Look, I know you’ve got issues with him, but he’s a stand-up guy and this is right up your alley.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Clayton Stahlman … yes, Laura had issues with him. She’d found the "), _c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("cure for his terminal illness—all illnesses, for that matter—and in return he’d made her rich enough to quit the Suffolk County Medical Examiner’s office and retrain for another field. But he’d played fast and loose with her during her travels for him, withholding critical information. In the end his tactic had wound up saving his own life as well as her daughter Marissa’s, so she couldn’t hold it against him. But the matter of trust remained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I don’t know …”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Hear me out. This is confidential, so you’ve gotta keep it to yourself, okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Easy enough, since she couldn’t imagine talking about Clayton Stahlman to anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“He’s got these people with … powers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Uh-oh. “Powers?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He laughed. God, she missed that laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Hey, I know that tone. And I know it sounds whacked out, but I met this guy tonight who can change the course of a pool ball just by wishing it into the pocket.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“ ‘Wishing’?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“I should have said ‘guiding.’ He guides it into the pocket with his mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You’re talking telekinesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Yeah. I am. Exactly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She felt disappointed. Rick was not the gullible type.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s a trick, Rick.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“No, Stahlman has computer analysis and—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“A trick. There’s no such thing as telekinesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“He’s got this neuroscience guy working for him and he sure seems convinced.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Every field has its share of kooks.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“I checked him out for Stahlman and Doc Montero is legit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“He might look good on the surface but—wait. Did you say Montero?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Yeah. Luis Montero. He’s got a Ph.D. in—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Neurobiology. Right-right-right. I’ve read some of his papers. And you’re telling me Stahlman has got Luis Montero on retainer?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“No retainer. Full-time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Well, this was interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick added, "), _c('i', [_vm._v("“The doc thinks these powers are related to some sort of brain waves and—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Okay. I’ll check it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“You will? Great. When’s good for you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Tomorrow morning. Marissa will be in school and—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“How’s she doing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Great. I just put her to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("She misses you terribly")]), _vm._v(" bubbled to her lips. A sad truth, but no way could she say it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick had hit it off with her nine-year-old Mets fanatic who insisted on using their proper name, the New York Metropolitans. Not a baseball fan—Rick claimed it put him to sleep—he’d nevertheless studied up on the team and had been able to trade stats with Marissa like a "), _c('i', [_vm._v("SportsCenter")]), _vm._v(" groupie.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Her Metropolitans have a chance for a wild-card slot again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So I’ve been told—endlessly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Hey, any chance I can drop in sometime and catch a game with her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Marissa would love that.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, she’s pretty busy, what with the new school year and all.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A pause, then, "), _c('i', [_vm._v("“Yeah, I can see that. Some other time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Yeah. That would be great.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“Want me to pick you up tomorrow?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Alone in a car together with nothing to talk about but "), _c('i', [_vm._v("us")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Better if I drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A quick, soft sigh. "), _c('i', [_vm._v("“Okay. It’s in Long-I City. I’ll text you the address and the time when it’s set up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Great.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("“See you tomorrow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She thumbed "), _c('i', [_vm._v("OFF")]), _vm._v(" and somehow managed to keep from throwing the phone across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("What’s the matter with me? Selfish bitch! Marissa would have loved to watch a game with Rick, but no, I’d be uncomfortable, and we couldn’t have "), _c('i', [_vm._v("that")]), _vm._v(", could we?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Get over yourself, dammit!")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She laid the phone—gently—on the counter and stalked to the sliding glass doors leading to the rear deck. With her arms folded across her chest she stared out at the backyard and saw nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She and Rick had been thrown together by Stahlman and started out with a tense, almost adversarial relationship. They’d journeyed through nine or ten countries on five continents, witnessed destruction and death, nearly died themselves a couple of times. They’d bonded, become friends—close "), _c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("friends—before they became lovers. The sex had been good—no, great—but then, as the two of them were sailing across the Mozambique Channel, he’d felt he had to come clean before they committed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("D"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ü")]), _vm._v("sseldorf. Goddamn D"), _c('span', {
    staticClass: "span-accent-characters--acc-"
  }, [_vm._v("ü")]), _vm._v("sseldorf.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("That had been the start of their unraveling. The affair carried on awhile longer, but then what he’d told her started to creep into bed with them, and soon she was finding excuses to put off seeing him, and eventually they stopped getting together at all.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("They’d been friends before they’d become intimate. Could they ever be just friends again after sharing each other like that?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She was friends with Steven these days. Her ex had betrayed her numerous times during their marriage, leaving her no choice but to call it quits. But now they shared Marissa without rancor or bitterness. Actually got along better than during the marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Rick had been totally honest and up front with her from the get-go and … she’d called it quits.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("What the hell’s the matter with me? Is anyone going to work out? What am I, some starry-eyed teen who thinks she’s going to find the perfect man? There "), _c('i', [_vm._v("is")]), _vm._v(" no perfect man. Not at my age. Not at "), _c('i', [_vm._v("any")]), _vm._v(" age!")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She felt her throat tighten and took a deep breath to ward off the threat of tears.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Okay. She’d put on her big-girl panties and go to Stahlman’s place tomorrow. No more of this avoidance bullshit. Rick was a brave, tough, decent man. They’d walked through fires together. They’d been friends before. That bond hadn’t dissolved. No reason they couldn’t be friends again.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Right?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Right?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f441ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0